import { createGlobalStyle } from 'styled-components';

export const GlobalStyles = createGlobalStyle`
.viewing-reservation-modal, .viewing-reservation-overlay {
    * {
        box-sizing: border-box;
    }

    h1 {
        color: ${({ theme }) => theme.colors.primary};
        font-size: 30px;
        font-weight: 400;
        text-align: center;
        text-align: center;
    }
    h2 {
        color: ${({ theme }) => theme.colors.primary};
        font-weight: 400;
        font-size: 22px;
        text-align: center;
        text-align: center;
        
        &:first-child {
          margin: 20px 0 20px 0 !important;
        }
    }

    p {
        margin-top: 20px;
        color: white;
        font-size: 16px;
        font-weight: 300;
        text-align: center;
    }

    a {
        color: ${({ theme }) => theme.colors.primary};
        text-decoration: none;
    }
}`;
